"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iLocalization = exports.iGetExcelInfo = exports.iTranslation = exports.iAllTranslationsStateData = exports.iTranslations = void 0;
const t = require("io-ts");
const User = require("./user");
exports.iTranslations = t.dictionary(t.string, t.string);
exports.iAllTranslationsStateData = t.dictionary(t.string, exports.iTranslations);
exports.iTranslation = t.interface({
    language: t.string,
    data: exports.iTranslations
});
exports.iGetExcelInfo = t.interface({
    user: User.iAuthor,
    filename: t.string,
    timestamp: t.string
});
exports.iLocalization = t.interface({
    language: t.string,
    translations: exports.iTranslations
});
//# sourceMappingURL=translations.js.map